var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5431 12.9247C17.4043 12.9247 16.2889 12.7469 15.2317 12.398C14.7157 12.2202 14.1298 12.3572 13.7907 12.7032L11.6949 14.286C9.29 13.0024 7.75089 11.4643 6.48483 9.07692L8.0249 7.03061C8.41259 6.64291 8.55155 6.07545 8.3854 5.54397C8.03364 4.48 7.85487 3.36356 7.85487 2.22672C7.85487 1.42314 7.20096 0.769226 6.39738 0.769226H2.99655C2.19298 0.769226 1.53906 1.42314 1.53906 2.22672C1.53906 11.6023 9.16757 19.2308 18.5431 19.2308C19.3467 19.2308 20.0006 18.5769 20.0006 17.7733V14.3822C20.0006 13.5786 19.3467 12.9247 18.5431 12.9247Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.c7c4fb2367f913e5d5f49817c4525c3a.svg";
export { ForwardRef as ReactComponent };